module.exports = __webpack_public_path__ + "img/coupon_en.90af7818.png";